import React from 'react';
import { ICourseReadonlyCardProps } from '../../entities/Card';
import { CourseReadonlyCard } from './CourseReadonlyCard';
import { withSelectable } from '../SelectContent/withSelectable';

export const SelectableCourseCard =
  withSelectable<React.PropsWithChildren<ICourseReadonlyCardProps>>(
    CourseReadonlyCard
  );
